import Vue from "vue";
import vuetify from "../vuetify.js";
import GalleryPaginationApp from "../components/gallery-pagination/GalleryPaginationApp.vue";

export default function() {
  const element = document.querySelector("#vue-gallery-pagination");

  if (element) {
      new Vue({
        el: element,

        computed: {
          images() {
            if (element.dataset.images) {
              return JSON.parse(element.dataset.images);
            }

            return [];
          }
        },

        vuetify,
        render: h => h(GalleryPaginationApp)
      })
  }
}
